export default "__VITE_ASSET__A0rzR2w9__"